<template>
  <div>
    <naj-data-table
      v-if="!isNewMode || formattedPreviousReplies.length"
      id="previous-replies-table"
      :headers="headers"
      :items="formattedPreviousReplies"
      hide-when-no-items
      disable-items-per-page
      show-expand
      no-header
    >
      <template v-slot:header>
        <div class="actions-buttons">
          <slot name="actions" />
        </div>
      </template>

      <template slot-scope="{ item }">
        {{ item.details.join(', ') }}
      </template>
    </naj-data-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapGetters } = createNamespacedHelpers('LawsuitModule');
export default {
  name: 'PreviousReplies',
  data () {
    return {
      headers: [
        {
          value: 'replyDate',
          text: this.local.previousReplies.colHijiriReplyDate,
        },
        {
          value: 'replyType',
          text: this.local.previousReplies.colReplyType,
        },
        {
          value: 'data-table-expand',
          text: this.local.previousReplies.colDataExpand,
          align: 'center',
        },
      ],
    };
  },
  computed: {
    ...mapState({ previousReplies: state => state.lawsuitRequest.previousReplies }),
    ...mapGetters(['isNewMode', 'isEditMode']),
    formattedPreviousReplies () {
      return this.previousReplies.map(r => ({
        ...r,
        isExpandable: +r.detailsCount > 0,
      }));
    },
    repliesExist () {
      return !!this.formattedPreviousReplies.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.actions-buttons {
  display: flex;
  justify-content: flex-end;
}
</style>
